var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavLocationOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2783 2.02051C9.67832 2.02051 4.27832 7.48679 4.27832 14.1678C4.27832 21.7352 13.222 28.1907 14.9545 29.4991C15.1435 29.6418 15.3342 29.7764 15.5561 29.8589C15.8036 29.951 16.0753 30.0205 16.2783 30.0205C16.4813 30.0205 16.7531 29.951 17.0005 29.8589C17.2224 29.7764 17.4132 29.6418 17.6021 29.4991C19.3346 28.1907 28.2783 21.7352 28.2783 14.1678C28.2783 7.48679 22.8783 2.02051 16.2783 2.02051Z",
    fill: "#F46940"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_479_4844)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2782 18.7215C18.8555 18.7215 20.9448 16.6322 20.9448 14.0549C20.9448 11.4775 18.8555 9.38818 16.2782 9.38818C13.7008 9.38818 11.6115 11.4775 11.6115 14.0549C11.6115 16.6322 13.7008 18.7215 16.2782 18.7215Z",
    stroke: "white",
    strokeWidth: 1.36241,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.278 8.05518V9.38851",
    stroke: "white",
    strokeWidth: 1.36241,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2779 14.0552H11.6112",
    stroke: "white",
    strokeWidth: 1.36241,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.278 18.7217V20.055",
    stroke: "white",
    strokeWidth: 1.36241,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9446 14.0552H22.2779",
    stroke: "white",
    strokeWidth: 1.36241,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_479_4844"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8.27832 6.05518)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavLocationOn);
export default __webpack_public_path__ + "static/media/navLocationOn.f6d1520ea09175637c185bf86ea6fbdf.svg";
export { ForwardRef as ReactComponent };